/* eslint-disable react-hooks/rules-of-hooks */
import { useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";

import { useBeneficiaryService } from "@/services/beneficiary.service";
import { setRelationshipList } from "@/redux/actions/global";

export const useGetRelationship = () => {
  const { relationshipList } = useSelector((state) => state.global);

  const {
    useGetRelationship: useGetRelationshipService,
  } = useBeneficiaryService();

  const dispatch = useDispatch();

  useEffect(() => {
    if (!relationshipList.length) {
      getRelationShip();
    }
  }, [relationshipList]);

  const getRelationShip = async () => {
    try {
      const { response } = await useGetRelationshipService();
      const { status, payload } = response;

      if (status.success) {
        dispatch(setRelationshipList(payload));
      }
    } catch (error) {
      dispatch(setRelationshipList([]));
    }
  };
};
